import { render, staticRenderFns } from "./sort-box.vue?vue&type=template&id=ee6bcb7a&scoped=true&"
import script from "./sort-box.vue?vue&type=script&lang=js&"
export * from "./sort-box.vue?vue&type=script&lang=js&"
import style0 from "./sort-box.vue?vue&type=style&index=0&id=ee6bcb7a&prod&lang=less&"
import style1 from "./sort-box.vue?vue&type=style&index=1&id=ee6bcb7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6bcb7a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
